import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService, ExportTaskProcessor } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { OfficeGroupService } from '../office-group.service';
import OfficeGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/office-group/office-group.entity';
import { LOCALIZED_PROPERTIES, OFFICE_GROUP_EXPORT_ID, OFFICE_GROUP_TITLE } from './office-group.constants';

@Injectable()
export class OfficeGroupExport {
  constructor(
    private exportService: ExportService,
    private officeGroupService: OfficeGroupService,
  ) {}

  private transformItem(item: OfficeGroupAttributes) {
    return {
      name: get(item, 'name', ''),
      company: get(item, 'company.name', ''),
      status: ExportTaskProcessor.types.ave.status(get(item, 'statusId', '')),
    };
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: OFFICE_GROUP_EXPORT_ID,
      title: OFFICE_GROUP_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(OFFICE_GROUP_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.officeGroupService.findByFilter(buildQuery(
          seed(this.officeGroupService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(OFFICE_GROUP_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(OFFICE_GROUP_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
